export * from 'locales';
